import React from 'react';
import { Card } from './ui/card';
import { Play, Calendar, Users } from 'lucide-react';

const SportsSection = () => {
  const handleCardClick = () => {
    // Scroll to hero CTA button
    document.getElementById('inicio')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  const sportsContent = [
    {
      id: 1,
      title: "Brasileirão Série A",
      match: "Flamengo vs Palmeiras",
      time: "Hoje às 19:00",
      viewers: "45.2K assistindo",
      image: "https://images.pexels.com/photos/1171084/pexels-photo-1171084.jpeg",
      isLive: true
    },
    {
      id: 2,
      title: "Champions League",
      match: "Real Madrid vs Manchester City",
      time: "Amanhã às 16:00",
      viewers: "125K interessados",
      image: "https://images.unsplash.com/photo-1522778119026-d647f0596c20",
      isLive: false
    },
    {
      id: 3,
      title: "NBA Finals",
      match: "Lakers vs Celtics",
      time: "Hoje às 22:00",
      viewers: "89K assistindo",
      image: "https://images.pexels.com/photos/2570139/pexels-photo-2570139.jpeg",
      isLive: true
    }
  ];

  return (
    <section id="esportes" className="py-16 md:py-24 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
            <span className="text-red-600">Esportes</span> Ao Vivo
          </h2>
          <p className="text-gray-400 text-lg md:text-xl">
            Acompanhe os principais jogos e campeonatos
          </p>
        </div>

        {/* Sports Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {sportsContent.map((sport) => (
            <Card
              key={sport.id}
              onClick={handleCardClick}
              className="group relative overflow-hidden bg-zinc-900 border-zinc-800 hover:border-red-600 transition-all duration-300 cursor-pointer hover:scale-105"
            >
              {/* Image */}
              <div className="relative h-48 md:h-64 overflow-hidden">
                <img
                  src={sport.image}
                  alt={sport.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-transparent"></div>

                {/* Live Badge */}
                {sport.isLive && (
                  <div className="absolute top-4 left-4 bg-red-600 text-white px-3 py-1 rounded-full text-sm font-bold flex items-center gap-2 animate-pulse">
                    <div className="w-2 h-2 bg-white rounded-full"></div>
                    AO VIVO
                  </div>
                )}

                {/* Play Overlay */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="bg-red-600 w-16 h-16 rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform">
                    <Play className="w-8 h-8 text-white fill-white" />
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-red-500 transition-colors">
                  {sport.title}
                </h3>
                <p className="text-gray-300 text-lg mb-4">{sport.match}</p>
                
                <div className="flex items-center justify-between text-sm text-gray-400">
                  <div className="flex items-center gap-2">
                    <Calendar className="w-4 h-4" />
                    {sport.time}
                  </div>
                  <div className="flex items-center gap-2">
                    <Users className="w-4 h-4" />
                    {sport.viewers}
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SportsSection;
